import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import TableComponentPage4 from "../../Table/GroupTable";
import ChartCheckbox from "../../Dashboard/Tools/ChartCheckbox";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { useSelector } from 'react-redux';

function CreateAffliateGroup() {
  const [affGrp, setAffGrp] = useState({
    name: "",
    members: []
  })
  const [members, setMembers] = useState([])
  const [affPages, setAffPages] = useState(1);
  const [username, setUsername] = useState("");
  const [affiliateFilter, setAffiliateFilter] = useState
    ({
      filters: {
        currency: "",
        commissiongroup: "",
        affiliategroup: "",
        language: "",
        btag: "",
        websiteid: "",
        status: "0"
      }
    })
  const [checkall, setCheckAll] = useState(true)
  const [resetTable, setResetTable] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(false);
  const [ploading, setPloading] = useState(false);
  const [validation, setValidation] = useState({
    name: null,
  })
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const getAllAffliates = async () => {
    setLoading(true)
    const response = await axios.post(window.__CFG.API + "affiliates/ListAffiliates?page=" + currentPage, { ...affiliateFilter, filters: { ...affiliateFilter.filters, username: username } }, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error == null) {
      setAffPages(response.data.Result.Pages)
      setMembers(response.data.Result.Data)
    }
    setLoading(false)

  }
  const resetTableState = () => {
    setSelectedRows([]);
    setResetTable(!resetTable); // This toggle forces the TableComponentPage4 to reset
  };
  const addAffiliateGrp = async () => {

    var initValidation = {
      name: null
    }
    if (affGrp.name == "") {
      initValidation.name = "name is required"

      setValidation(initValidation)
      return toast.error(initValidation.name, {
        duration: 2000
      });
    }
    else {
      var selectedAffilates = []
      if (selectedRows.length > 0) {
        selectedRows.forEach(aff => {
          selectedAffilates.push(aff.id)
        })
        affGrp.members = selectedAffilates;
      } else {
        affGrp.members = [];
      }
        setPloading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/CreateAffiliateGroup", affGrp, {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem("raff-token")
          }
        })

        setPloading(false);

        if (response.data.Error == null) {
          toast.success("Group Created Successfully", {
            duration: 4000
          });
          resetTableState()

        }
      // }
      // else {
      //   toast.error("Please select affiliate", {
      //     duration: 2000
      //   });
      // }
    }
  }
  useEffect(() => { getAllAffliates() }, [affPages, affiliateFilter, username])
  useEffect(() => { setAffliatePermission(checkPermission(affliate, "aff_add_affiliate_group")) }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  const memberscolumns = React.useMemo(
    () => [
      {
        Header: "Affiliate ID",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Site",
        accessor: "site",
      }
    ],
    []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Affiliate ID",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Site",
        accessor: "site",
      },
      {
        Header: "Registeation date",
        accessor: "registrationdate",
      },

      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  const handleSelectedRowsChange = (selectedRows) => {
    setSelectedRows(selectedRows);
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)

  return (
    <>
      <Container>
        <Row>
          <Col>
            <Row className="justify-content-start mt-5 me-auto w-75">
              <Col lg={4} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp-gd">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Group name </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} value={affGrp.name} className={validation.name != null ? ("error-form-add") : ("")} type="text" onChange={e => setAffGrp({ ...affGrp, name: e.target.value })} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-start mt-3 me-auto w-75">
              <Col lg={4} md={4} sm={4}>
                <div className="form-cre-grp-fl-wp-gd">
                  <div className="form-cre-grp-fl-wp-lb">
                    <label>Currency </label>
                  </div>
                  <div className="form-cre-grp-fl-wp-in">
                    <Select options={optionsCurrency} value={selectedCurrencyValue} />

                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between mt-4  w-100">
              <Col lg={6} md={4} sm={4}>
                <div style={{ display: "flex", alignItems: "center" }} >
                  <div>
                    <ChartCheckbox initialChecked={false} label="" size="13px" />
                  </div>
                  <div style={{ marginLeft: 15 }}>
                    <label
                      htmlFor="custom-checkbox"
                      className="text-gray-700 cursor-pointer"
                    >
                      Non-group partners only
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
            <div style={{ paddingBottom: 10 }}>
              <h4 className="text-start mt-2">Add members</h4>
            </div>
            <Row className="justify-content-between mt-0">
              <Col lg={3} md={4} sm={4}>
                <div className='add-affiliate-searchInput' style={{ paddingBottom: 10 }}>
                  <div style={{ position: "absolute" }} className="search-container">
                    <Form.Control onChange={e => setUsername(e.target.value)} style={{ padding: 2, minWidth: 190 }} type="text" className="search-input" placeholder="Search" />
                    <i class="fa-solid fa-magnifying-glass" style={{ position: "absolute", right: 10, top: 8 }}></i>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className=" mb-4">
              <div className="aff-dash-summary-table">
                <TableComponentPage4 columns={columns} data={affliatePermission ? members : []} key={resetTable} onSelectedRowsChange={handleSelectedRowsChange} Pages={affPages} currentPage={currentPage} onPageChange={handlePageChange} loading={loading} />
              </div>
            </Row>
            {selectedRows.length < 1 ? (
              <></>) : (
              <>
                <div className="animate__animated animate__fadeInDown">
                  <h4 className="text-start mt-2">Selected members</h4>
                  <Row className=" mb-4 ">
                    <div className="aff-dash-summary-table ">
                      <TableComponentPage4 columns={memberscolumns} data={selectedRows} selectedCheckbox={checkall} hiddenPagination={true} />
                    </div>
                  </Row>
                </div>
              </>)}
            <Row className="mt-5 me-4 w-100 mb-5">
              <Col lg={3} md={4} sm={5} className=" pt-2">
                <Button disabled={ploading || !affliatePermission} onClick={addAffiliateGrp} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp">
                  {ploading ? <Spinner size="sm" /> : <>Create group</>}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CreateAffliateGroup;
